import { HttpInterceptorFn } from '@angular/common/http';
import { InjectionToken, inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';

import { CipError } from '@mobi/rwc-utils-azure-ng-jslib';

export type CipErrorHandler = (cipError: CipError) => void;

export const CIP_ERROR_HANDLER = new InjectionToken<CipErrorHandler>('Handler function for CIP authentication errors');

export const cipErrorInterceptor: HttpInterceptorFn = (req, next) => {
    const errorHandler = inject(CIP_ERROR_HANDLER);
    return next(req).pipe(
        catchError(exception => {
            if (exception instanceof CipError) {
                errorHandler(exception);
            }
            return throwError(() => exception);
        })
    );
};
